var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"height":"100% !important","width":"100% !important"},attrs:{"frameborder":"0","allowfullscreen":"true","allow":"fullscreen; accelerometer; gyroscope; magnetometer; vr; camera; microphone","src":_vm.iframeSource()}})}
var staticRenderFns = []

export { render, staticRenderFns }